import {RankedProgressBarView} from '../../ui_canvas_engine/RankedProgressBarView'
import {UIGameManager} from '../UIGameManager'
import {BaseAnimationWrapper} from './BaseAnimationWrapper'

export class RankedProgressBarAnimationWrapper extends BaseAnimationWrapper {
    private readonly object: RankedProgressBarView

    constructor(object: RankedProgressBarView, uiGameManager: UIGameManager, startValue: number, endValue: number, duration: number, startingDelay: number = 0) {
        super(uiGameManager, startValue, endValue, duration, startingDelay)
        this.object = object
        this.setValue(startValue)
    }

    protected setValue(amount: number) {
        if(this.object.destroyed) return
        this.object.percentage = amount
    }
}
